/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { injectIntl } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';

const date = new Date().getFullYear();

const style = { color: '#002C40', fontSize: 20, fontWeight: 600 };

function MaintenancePage({ intl }) {
  const images = ['/media/bg/senseworks-1.jpg', '/media/bg/senseworks-2.jpg'];
  const selectedImage = images[Math.round(Math.random())];

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl(selectedImage)})`,
            }}
          ></div>
          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden space-between">
            <div className="h-100 d-flex flex-column flex-center">
              <div className="d-flex flex-column align-items-center justify-content-center">
                <img
                  src={toAbsoluteUrl('/media/logos/logo-login.png')}
                  width="300px"
                  height="100px"
                  alt="SenseWorks"
                />
                <img
                  src={toAbsoluteUrl('/media/senseworks/maintenance.png')}
                  className="mt-10"
                  width="300px"
                  height="300px"
                  alt="SenseWorks"
                />
              </div>
              <div className="d-flex flex-column flex-center mt-10">
                <span style={style}>
                  {' '}
                  {intl.formatMessage({ id: 'MAINTENANCE' })}{' '}
                </span>
                <span style={style} className="d-block">
                  {' '}
                  {intl.formatMessage({ id: 'TRY_AGAIN_LATER' })}{' '}
                </span>
              </div>
            </div>
            <div className="flex-column-auto d-lg-flex justify-content-between mt-10">
              <span className="text-muted">
                {date} © SenseWorks Tecnologia Ltda. All rights reserved.
              </span>
            </div>
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}

export default injectIntl(MaintenancePage);
